import React, { useContext } from "react";
import { Grid, withStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { clearCache as clearCacheApi } from "../../../../API/System";
import ModalDialogContext from "../../../../Context/ModalDialog/ModalDialogContext";
import { styles } from "./styles";
import { useTranslation } from "react-i18next";

const SystemActions = (props) => {
  const {
    showMessage, showErrorMessage
  } = useContext(ModalDialogContext);
  const { t } = useTranslation();

  const clearCache = async () => {
    try {
      await clearCacheApi();
      showMessage({ message: t("messages.admin.cacheClearedSuccessfully") });
    } catch (error) {
      showErrorMessage({ error });
    }
  }

  const { classes } = props;
  return (
    <Grid container className={classes.marginTop} justify="center">
      <Grid item>
        <Button color="primary" variant="contained" onClick={clearCache}>
          {t("labels.admin.clearCache")}
        </Button>
      </Grid>
    </Grid>
  );
}

export default withStyles(styles, { withTheme: true })(SystemActions);
